module.exports = __webpack_public_path__ + "shanz/static/media/gadgetnews.11170f1e.png";